/**
 * Diagnostics service — admin-facing per-employee agent liveness.
 *
 * Mirrors the shape returned by `GET /api/agents/diagnostics` and
 * `GET /api/agents/:id/diagnostics`. The page auto-refreshes every 30s
 * so the admin can see liveness change without an F5.
 */
import type {
  AgentDiag,
  AgentDiagDetail,
  AgentDiagSummary,
} from '@monitor/shared'
import { httpClient } from '@/lib/axios'

export interface ListParams {
  page?: number
  pageSize?: number
  search?: string
  isOnline?: boolean
  department?: string
}

export interface ListResponse {
  items: AgentDiag[]
  total: number
  page: number
  pageSize: number
  summary: AgentDiagSummary
}

export const diagnosticsService = {
  async list(params: ListParams = {}): Promise<ListResponse> {
    const r = await httpClient.get<ListResponse>('/api/agents/diagnostics', { params })
    return r.data
  },
  async detail(id: number): Promise<AgentDiagDetail> {
    const r = await httpClient.get<AgentDiagDetail>(`/api/agents/${id}/diagnostics`)
    return r.data
  },
}
